import React from "react";
import { ModalShell } from "../ui/ModalShell";
import { RelatedOrderDTO } from "../types";
import {BtnSpinner} from "../../../../components/fields/BtnSpinner";

export function DeleteModal({
                                item,
                                isDeleting,
                                relatedOrders,
                                isLoadingRelatedOrders,
                                onClose,
                                onConfirm,
                            }: {
    item: { id: number; title: string; kind: "current" | "scheduled" };
    isDeleting: boolean;
    relatedOrders: RelatedOrderDTO[];
    isLoadingRelatedOrders: boolean;
    onClose: () => void;
    onConfirm: () => void;
}) {
    return (
        <ModalShell onClose={onClose} className="supplies-delete-modal">
            <h2 className="supplies-modal-title">Удалить</h2>

            <p className="supplies-delete-text">
                Вы действительно хотите удалить <strong>{item.title}</strong>?
            </p>

            {item.kind === "current" && (
                <>
                    <p className="supplies-delete-warning">При удалении текущей поставки удаляются все связанные заказы.</p>

                    <div style={{ marginTop: 10 }}>
                        <div className="admin_title" style={{ marginBottom: 6 }}>
                            Связанные заказы
                        </div>

                        {isLoadingRelatedOrders && (
                            <div className="admin-table-loading" style={{ padding: "10px 0" }}>
                                <span className="admin-spinner" /> Загрузка...
                            </div>
                        )}

                        {!isLoadingRelatedOrders && relatedOrders.length === 0 && (
                            <div style={{ fontSize: 12, opacity: 0.8 }}>Заказы не найдены.</div>
                        )}

                        {!isLoadingRelatedOrders && relatedOrders.length > 0 && (
                            <div className="admin-table-wrapper" style={{ marginTop: 8 }}>
                                <table className="admin_table supplies-table" style={{ marginBottom: 0 }}>
                                    <thead>
                                    <tr>
                                        <th>Entity</th>
                                        <th>Телефон</th>
                                        <th>Город</th>
                                        <th>Оплата</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {relatedOrders.slice(0, 50).map((o) => (
                                        <tr key={o.id}>
                                            <td>{o.entity || "—"}</td>
                                            <td>{o.phoneNumber || "—"}</td>
                                            <td>{o.sendCity || "—"}</td>
                                            <td>{o.paymentStatus ? "Оплачено" : "Не оплачено"}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </>
            )}

            <div className="supplies-modal-actions" style={{ marginTop: 14 }}>
                <button className="admin-button-secondary admin-button-secondary--ghost" onClick={onClose} disabled={isDeleting}>
                    Отмена
                </button>

                <button className="admin-button-secondary admin-button-secondary--danger" onClick={onConfirm} disabled={isDeleting}>
                    {isDeleting ? (
                        <>
                            <BtnSpinner/>
                        </>
                    ) : (
                        "Удалить"
                    )}
                </button>
            </div>
        </ModalShell>
    );
}
